<template>
  <div class="categories-page">
    <div class="page-card">
      <div class="toolbar">
        <span class="page-desc">管理文章分类，将影响文章列表的筛选和展示</span>
        <button class="btn-primary" @click="openCreate">+ 新建分类</button>
      </div>

      <div v-if="loading" class="loading">加载中...</div>

      <div v-else-if="list.length === 0" class="empty">暂无分类</div>

      <table v-else class="data-table">
        <thead>
          <tr>
            <th style="width:80px">ID</th>
            <th>分类名称</th>
            <th style="width:100px">排序</th>
            <th style="width:100px">文章数</th>
            <th style="width:100px">商品数</th>
            <th style="width:100px">资源数</th>
            <th style="width:180px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in list" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.sort_order }}</td>
            <td>{{ item.article_count || 0 }}</td>
            <td>{{ item.product_count || 0 }}</td>
            <td>{{ item.free_count || 0 }}</td>
            <td>
              <button class="btn-action" @click="openEdit(item)">编辑</button>
              <button class="btn-action btn-danger" @click="handleDelete(item)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 新建/编辑弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-box">
        <h3>{{ isEdit ? '编辑分类' : '新建分类' }}</h3>
        <div class="modal-form">
          <div class="form-item">
            <label>分类名称 <span class="required">*</span></label>
            <input v-model="modalForm.name" type="text" placeholder="请输入分类名称" />
          </div>
          <div class="form-item">
            <label>排序（越小越靠前）</label>
            <input v-model.number="modalForm.sort_order" type="number" placeholder="0" />
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn-cancel" @click="showModal = false">取消</button>
          <button class="btn-primary" @click="handleSave" :disabled="saving">
            {{ saving ? '保存中...' : '确认' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 删除确认 -->
    <div v-if="showDelete" class="modal-overlay" @click.self="showDelete = false">
      <div class="modal-box">
        <h3>确认删除</h3>
        <p>确定要删除分类「{{ deleteTarget ? deleteTarget.name : '' }}」吗？该分类下的文章将被设为"未分类"。</p>
        <div class="modal-actions">
          <button class="btn-cancel" @click="showDelete = false">取消</button>
          <button class="btn-primary" @click="confirmDelete">确认删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../api/index';

export default {
  name: 'CategoriesList',
  data() {
    return {
      list: [],
      loading: false,
      showModal: false,
      showDelete: false,
      isEdit: false,
      modalForm: { id: null, name: '', sort_order: 0 },
      deleteTarget: null,
      saving: false,
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await request('/categories.php');
        this.list = res.data;
      } catch (e) {
        alert('加载失败: ' + e.message);
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.isEdit = false;
      this.modalForm = { id: null, name: '', sort_order: 0 };
      this.showModal = true;
    },
    openEdit(item) {
      this.isEdit = true;
      this.modalForm = { id: item.id, name: item.name, sort_order: item.sort_order };
      this.showModal = true;
    },
    async handleSave() {
      if (!this.modalForm.name.trim()) {
        alert('请输入分类名称');
        return;
      }
      this.saving = true;
      try {
        const method = this.isEdit ? 'PUT' : 'POST';
        const body = this.isEdit
          ? { id: this.modalForm.id, name: this.modalForm.name, sort_order: this.modalForm.sort_order }
          : { name: this.modalForm.name, sort_order: this.modalForm.sort_order };
        await request('/categories.php', { method, body });
        this.showModal = false;
        this.fetchList();
      } catch (e) {
        alert('保存失败: ' + e.message);
      } finally {
        this.saving = false;
      }
    },
    handleDelete(item) {
      this.deleteTarget = item;
      this.showDelete = true;
    },
    async confirmDelete() {
      if (!this.deleteTarget) return;
      try {
        await request('/categories.php?id=' + this.deleteTarget.id, { method: 'DELETE' });
        this.showDelete = false;
        this.deleteTarget = null;
        this.fetchList();
      } catch (e) {
        alert('删除失败: ' + e.message);
      }
    },
  },
};
</script>

<style scoped>
.categories-page { width: 100%; }

.page-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-desc { color: #999; font-size: 13px; }

.btn-primary {
  height: 36px;
  padding: 0 20px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary:hover { background: #4096ff; }
.btn-primary:disabled { background: #a0c4ff; cursor: not-allowed; }

.loading, .empty { text-align: center; padding: 60px 0; color: #999; }

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table th {
  background: #fafafa;
  padding: 12px 12px;
  text-align: left;
  font-weight: 500;
  color: #666;
  border-bottom: 2px solid #f0f0f0;
}

.data-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #f0f0f0;
}

.data-table tr:hover { background: #fafafa; }

.btn-action {
  padding: 4px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  margin-right: 8px;
}

.btn-action:hover { border-color: #1677FF; color: #1677FF; }
.btn-action.btn-danger { color: #ff4d4f; border-color: #ffccc7; }
.btn-action.btn-danger:hover { background: #ff4d4f; color: #fff; border-color: #ff4d4f; }

/* Modal */
.modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}

.modal-box {
  width: 420px;
  background: #fff;
  border-radius: 8px;
  padding: 32px;
}

.modal-box h3 { font-size: 18px; margin-bottom: 20px; }

.modal-form { margin-bottom: 24px; }

.form-item { margin-bottom: 14px; }

.form-item label { display: block; margin-bottom: 6px; font-size: 14px; color: #555; }
.required { color: #ff4d4f; }

.form-item input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.form-item input:focus { border-color: #1677FF; box-shadow: 0 0 0 2px rgba(22,119,255,0.1); }

.modal-actions { display: flex; justify-content: flex-end; gap: 12px; }

.btn-cancel {
  height: 36px;
  padding: 0 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel:hover { border-color: #1677FF; color: #1677FF; }
</style>
